module.exports = __webpack_public_path__ + "static/media/poste_22.c9ca8bd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_22.jpg
// module id = 251
// module chunks = 0